<script lang="ts">
  import { goto } from '$app/navigation';

  goto('/admin/classes');
</script>
